import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Autocomplete  from '@mui/material/Autocomplete';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import location from "../../components/profile/profileCompletion/images/location.png"
import mobile from "../../components/profile/profileCompletion/images/mobile.png"
import phoneNumberExistResponse from "../../apis/users/getUserDataByPhoneNumber";
import updateUserResponse from "../../apis/users/updateUsers";
import cross from "../../components/profile/profileCompletion/images/cross.svg"
import pencil from "../../components/profile/profileCompletion/images/pencil.png";
import PhoneInput, { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import profileById from '../../apis/profile/profileById'
import updateProfile from "../../apis/profile/updateProfile";
import TextField from "@mui/material/TextField";
import Tooltip from '@mui/material/Tooltip';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import LinkedIn from "../../components/profile/resume/images/linkedIn.svg"
import fetchCountryStateCity from "../../apis/fetchCountryStateCity";
import {
  NotificationManager,
} from "react-notifications";

const styleSx = {
  buttonAlignForRemove: {
    padding: "32px!important",
  },
  bodyForRemove: {
    padding: "26px 24px 0px 24px!important",
    marginTop: "0px!important",
  },
};

const PersonalInformation = ({ idContextTest, props, setLastUpdate, profileData }) => {
  const [locationCountry, setLocationCountry] = useState("");
  const [locationState, setLocationState] = useState("");
  const [locationCity, setLocationCity] = useState("");
  const [linkedIn, setLinkedIn] = useState("");
  const [openLinkedIn, setOpenLinkedIn] = useState(false);
  const [urlValue, setUrlValue] = useState("");
  const [editprofileModal, setEditprofileModal] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [loadingController, setLoadingController] = useState(false);

  const [modalFirstName, setModalFirstName] = useState("");
  const [modalLastNames, setModalLastNames] = useState("");
  const [modalMiddleInitial, setmodalMiddleInitial] = useState("");
  const [totalExpYearSelected, setTotalExpYearSelected] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [availablephnno, setavailablephnno] = useState("");
  const [phoneNoIntnl, setPhoneNoIntnl] = useState("");
  const [phoneNumberEditModal, setPhoneNumberEditModal] = useState("");
  const [countryCodeEditModal, setCountryCodeEditModal] = useState("");
  const [phoneNumberChanged, setPhoneNumberChanged] = useState(false)
  const [defaultCountryCode, setDefaultCountryCode] = useState("")
  const [userEmail, setUserEmail] = useState("");
  const [countryCode, setcountryCode] = useState("")

  // New state structure
  const [locationList, setLocationList] = useState({
    countryList: [],
    stateList: [],
    cityList: [],
    isCountryFetching: false,
    isStateFetching: false,
    isCityFetching: false,
  });

  const [userInformation, setUserInformation] = useState({
    locationCountry: {},
    locationState: {},
    locationCity: {},
  });

    useEffect(() => {
        getProfileDatas();
      }, [profileData])

    const updateUrl = async () => {
        var expression =/^(https?:\/\/(.+?\.)?(www\.)?linkedin\.com(\/[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=]*)?)/gi
        var regex = new RegExp(expression);
        if (urlValue !== null || urlValue !== "") {
          if (!urlValue.match(regex)) {
            NotificationManager.error("Enter a correct linkedIn Url", "error",10000);
            return;
          }
        }
        const data = {
          linkedInUrl: urlValue,
        };
        try {
          const payload = {
            id: idContextTest,
            data: data,
          }
          await updateProfile(payload);
          setLinkedIn(urlValue);
          setUrlValue(urlValue);
          setOpenLinkedIn(false);
        } catch (error) {
          NotificationManager.error("URL updation failed", "Error",10000);
        }
      };


      const closeLinkedModal = () => {
        setOpenLinkedIn(false);
        getProfileDatas();

      };
      const openEditProfileModal = async () => {
        await setModaldata();
    
        setEditprofileModal(true);
      };
    
      const useStylesBootstrap ={
        arrow: {
          color: "#1A8FFF",
        },
        tooltip: {
          backgroundColor: "#1A8FFF",
          padding: "4px 13px",
          fontFamily: "Segoe-Semibold",
          fontSize: "13px"
        },
      };
    function BootstrapTooltip(props) {
      return <Tooltip arrow sx={useStylesBootstrap} {...props} />;
    }

      const getProfileDatas = async () => {
        try {

          setLinkedIn(profileData.linkedInUrl || "");
          setUrlValue(profileData.linkedInUrl || "");

          setLastUpdate(profileData.lastUpdated);
          setphoneNumber(profileData.user.phoneNumber || "");
          setavailablephnno(profileData.user.phoneNumber || "");
          setUserEmail(profileData.user.email);
          setTotalExpYearSelected(profileData.totalExperienceId);
          setLocationCountry(JSON.parse(profileData.locationCountry).name);
          setLocationCity(JSON.parse(profileData.locationCity).name);
          setPhoneNoIntnl(profileData.user.countryCode + "" + profileData.user.phoneNumber)
          setcountryCode(profileData.user.countryCode)
          setDefaultCountryCode(profileData.user.countryCode ? "" : JSON.parse(profileData.locationCountry).isoCode)
          if (profileData.locationState !== "") {
            setLocationState(JSON.parse(profileData.locationState).name || "");
          }
          if (profileData.locationCountry) {
            var countryData = JSON.parse(profileData.locationCountry);
            try {
              let payload = {
                actionName: "state",
                countryCode: countryData.isoCode
              }
              let response = await fetchCountryStateCity(payload);
              if (response.status === 200) {
                setLocationList(prev => ({
                  ...prev,
                  stateList: response.data.data
                }));
              }
            } catch (error) {
              console.log("Error loading states:", error);
            }
          }

          // Load cities for the current state using API
          if (profileData.locationState) {
            var stateData = JSON.parse(profileData.locationState);
            try {
              let payload = {
                actionName: "city",
                stateCode: stateData.isoCode
              }
              let response = await fetchCountryStateCity(payload);
              if (response.status === 200) {
                setLocationList(prev => ({
                  ...prev,
                  cityList: response.data.data
                }));
              }
            } catch (error) {
              console.log("Error loading cities:", error);
            }
          }

          setLoadingController(true);
        } catch (error) {
          console.log(error);
        }
      };

  const fetchLocationInformation = async (field) => {
    if (field === "country") {
      setLocationList((prev) => ({
        ...prev,
        isCountryFetching: true,
      }));
      try {
        let payload = {
          actionName: "country"
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList({
            ...locationList,
            isCountryFetching: false,
            countryList: response.data.data
          })
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load country list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isCountryFetching: false,
          countryList: [],
        }));
      }
    }
    else if (field === "state") {
      setLocationList((prev) => ({
        ...prev,
        isStateFetching: true,
      }));
      try {

        let payload = {
          actionName: "state",
          countryCode: userInformation.locationCountry.isoCode
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList({
            ...locationList,
            isStateFetching: false,
            stateList: response.data.data
          })
        }

      } catch (error) {
        NotificationManager.error(
          "Unable to load state list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isStateFetching: false,
          stateList: [],
        }));

      }
    }
    else if (field === "city") {
      setLocationList((prev) => ({
        ...prev,
        isCityFetching: true,
      }));
      try {
        let payload = {
          actionName: "city",
          stateCode: userInformation.locationState.isoCode,
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList({
            ...locationList,
            isCityFetching: false,
            cityList: response.data.data
          })
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load city list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isCityFetching: false,
          cityList: [],
        }));
      }
    }
  }

  const getProfileData = async () => {
    try {
          const profileResponse = await profileById(idContextTest);
          setLoadingController(true);
          var profileDataParsed = profileResponse.data.data[0];
          setLastUpdate(profileDataParsed.lastUpdated);
          setphoneNumber(profileDataParsed.user.phoneNumber || "");
          setavailablephnno(profileDataParsed.user.phoneNumber || "");
          setTotalExpYearSelected(profileDataParsed.totalExperienceId);
          setLocationCountry(JSON.parse(profileDataParsed.locationCountry).name);
          setLocationCity(JSON.parse(profileDataParsed.locationCity).name);
          setPhoneNoIntnl(profileDataParsed.user.countryCode + "" + profileDataParsed.user.phoneNumber)
          setcountryCode(profileDataParsed.user.countryCode)
          setDefaultCountryCode(profileDataParsed.user.countryCode ? "" : JSON.parse(profileDataParsed.locationCountry).isoCode)

          if (profileDataParsed.locationState !== "") {
            setLocationState(JSON.parse(profileDataParsed.locationState).name || "");
          }

          // Load states for the current country using API
          if (profileDataParsed.locationCountry) {
            var countryData = JSON.parse(profileDataParsed.locationCountry);
            try {
              let payload = {
                actionName: "state",
                countryCode: countryData.isoCode
              }
              let response = await fetchCountryStateCity(payload);
              if (response.status === 200) {
                setLocationList(prev => ({
                  ...prev,
                  stateList: response.data.data
                }));
              }
            } catch (error) {
              console.log("Error loading states:", error);
            }
          }

          // Load cities for the current state using API
          if (profileDataParsed.locationState) {
            var stateData = JSON.parse(profileDataParsed.locationState);
            try {
              let payload = {
                actionName: "city",
                stateCode: stateData.isoCode
              }
              let response = await fetchCountryStateCity(payload);
              if (response.status === 200) {
                setLocationList(prev => ({
                  ...prev,
                  cityList: response.data.data
                }));
              }
            } catch (error) {
              console.log("Error loading cities:", error);
            }
          }
        } catch (error) {
          console.log(error);
        }
      };

      const openLinkInWinDow = (e, linkedIn) => {
        if (linkedIn) {
          window.open(linkedIn);
        }
      };
      const openLinkedInModal = () => {
        setOpenLinkedIn(true);
      };


    const phoneNumberChangeHandler = (val) => {
      setPhoneNoIntnl(val)
      setPhoneNumberChanged(true);
      if (val) {
        if (val && isPossiblePhoneNumber(val)) {
          setPhoneError(false)
          setCountryCodeEditModal(`+${parsePhoneNumber(val).countryCallingCode}`);
          let countryCode_PhoneNumber = `+${parsePhoneNumber(val).countryCallingCode}`
          setPhoneNumberEditModal(val.replace(countryCode_PhoneNumber, ""));
        }
        else {
          setPhoneError(true)
        }
      }
      else {
        setPhoneError(false)
        setCountryCodeEditModal("")
        setPhoneNumberEditModal("")
      }
    };

    const closeEditProfileModal = async () => {
      await getProfileData();
      setPhoneError(false)
      setEditprofileModal(false)
    }

    const keypressHandler = (e) => {
        var invalidChars = [
          "-",
          "+",
          "e",
        ];
        if (invalidChars.includes(e.key)) {
          e.preventDefault();
        }
      }

  const setModaldata = async () => {
    let arrayDataYears = [];
    for (let i = 0; i <= 20; i++) {
      arrayDataYears.push(i);
    }
    let arrayDataMonths = [];
    for (let i = 0; i <= 11; i++) {
      arrayDataMonths.push(i);
    }

    setModalFirstName(profileData?.user?.firstName);
    setModalLastNames(profileData?.user?.lastName);
    setmodalMiddleInitial(profileData?.user?.MiddleInitial);
    setphoneNumber(profileData?.user?.phoneNumber || "")

    // Updated to use new state structure
    let locationCountryData = {};
    let locationStateData = {};
    let locationCityData = {};

    if (profileData.locationCountry) {
      locationCountryData = JSON.parse(profileData.locationCountry);
    }
    if (profileData.locationState) {
      locationStateData = JSON.parse(profileData.locationState);
    }
    if (profileData.locationCity) {
      locationCityData = JSON.parse(profileData.locationCity);
    }

    setUserInformation({
      locationCountry: locationCountryData,
      locationState: locationStateData,
      locationCity: locationCityData,
    });
  }

  

  const countryHandler = async (event, value) => {
    setUserInformation(prev => ({
      ...prev,
      locationCountry: value || {},
      locationState: {},
      locationCity: {}
    }));

    if (value) {
      // Load states for selected country using API
      setLocationList(prev => ({
        ...prev,
        isStateFetching: true,
        stateList: [],
        cityList: []
      }));
      
      try {
        let payload = {
          actionName: "state",
          countryCode: value.isoCode
        }
        let response = await fetchCountryStateCity(payload);
        if (response.status === 200) {
          setLocationList(prev => ({
            ...prev,
            isStateFetching: false,
            stateList: response.data.data
          }));
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load state list. Please try again later.",
          "Error",
          10000
        )
        setLocationList(prev => ({
          ...prev,
          isStateFetching: false,
          stateList: [],
        }));
      }
    } else {
      setLocationList(prev => ({
        ...prev,
        stateList: [],
        cityList: []
      }));
    }
  };

  const stateHandler = async (event, value) => {
    setUserInformation(prev => ({
      ...prev,
      locationState: value || {},
      locationCity: {}
    }));

    if (value) {
      // Load cities for selected state using API
      setLocationList(prev => ({
        ...prev,
        isCityFetching: true,
        cityList: []
      }));
      
      try {
        let payload = {
          actionName: "city",
          stateCode: value.isoCode
        }
        let response = await fetchCountryStateCity(payload);
        if (response.status === 200) {
          setLocationList(prev => ({
            ...prev,
            isCityFetching: false,
            cityList: response.data.data
          }));
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load city list. Please try again later.",
          "Error",
          10000
        )
        setLocationList(prev => ({
          ...prev,
          isCityFetching: false,
          cityList: [],
        }));
      }
    } else {
      setLocationList(prev => ({
        ...prev,
        cityList: []
      }));
    }
  };

  const cityHandler = async (event, value) => {
    setUserInformation(prev => ({
      ...prev,
      locationCity: value || {}
    }));
  };

  // phone no validation chk api call
      const checkForDuplicatePhoneNumber = async (phoneNumber) => {
        var phnnoinput = {
          "phoneNumber": phoneNumber
        }
        try {
          const phoneNochkResponse = await phoneNumberExistResponse(phnnoinput);
          if (phoneNochkResponse.data.data[0].isUnique === true) {
            return (phoneNochkResponse.data.data[0].isUnique)
          }
        } catch (error) {
          console.log(error);
        }
      }

      const updateProfileData = async () => {
        if (modalFirstName === "" || modalLastNames === "" || totalExpYearSelected === "" ||
          Object.keys(userInformation.locationCountry).length === 0 ||
          Object.keys(userInformation.locationState).length === 0 ||
          phoneNoIntnl === undefined) {
          NotificationManager.error("Please enter the required fields", "Error", 10000);
        }
        else if (phoneError) {
          NotificationManager.error("Please enter a valid phone number", "Error", 10000);
        }
        else {
          let userData = {
            firstName: modalFirstName,
            lastName: modalLastNames,
            locationCountry: JSON.stringify(userInformation.locationCountry),
            MiddleInitial: modalMiddleInitial,
            updatedBy: idContextTest,
            isActive: true,
          };
          let isunique = true;

          if (phoneNumberChanged === true && phoneNumberEditModal !== "") {
            if (phoneNumberEditModal !== availablephnno) {
              isunique = await checkForDuplicatePhoneNumber(phoneNumberEditModal);
            }
            userData.phoneNumber = phoneNumberEditModal
            userData.countryCode = countryCodeEditModal

            if (isunique) {
              try {
                const payload = {
                  id: idContextTest,
                  data: userData
                }
                await updateUserResponse(payload);
              } catch (error) { console.error(error); }

              let profileDataRequest = {
                totalExperienceId: totalExpYearSelected,
                locationCountry: JSON.stringify(userInformation.locationCountry),
                locationState: JSON.stringify(userInformation.locationState),
                locationCity: JSON.stringify(userInformation.locationCity),
                updatedBy: idContextTest,
              };
              try {
                const payload = {
                  id: idContextTest,
                  data: profileDataRequest,
                }
                await updateProfile(payload);
                NotificationManager.success("Profile updated", "Success",10000);
                await getProfileData();
                setEditprofileModal(false);
              } catch (error) { console.error(error); }
            }
            else {
              NotificationManager.error("Phone Number Already Exists In Our System", "Error",10000);
            }
          }
          else {
            let userData = {
              phoneNumber: phoneNumberChanged ? "" : phoneNumber,
              countryCode: phoneNumberChanged ? "" : countryCode,
              firstName: modalFirstName,
              lastName: modalLastNames,
              locationCountry: JSON.stringify(userInformation.locationCountry),
              MiddleInitial: modalMiddleInitial,
              updatedBy: idContextTest,
              isActive: true,
            };
            try {
              const payload = {
                id: idContextTest,
                data: userData,
              }
              await updateUserResponse(payload);
            } catch (error) { console.error(error); }

            let profileDataRequest = {
              totalExperienceId: totalExpYearSelected,
              locationCountry: JSON.stringify(userInformation.locationCountry),
              locationState: JSON.stringify(userInformation.locationState),
              locationCity: JSON.stringify(userInformation.locationCity),
              updatedBy: idContextTest,
            };
            try {
              const payload = {
                id: idContextTest,
                data: profileDataRequest,
              }
              await updateProfile(payload);
              NotificationManager.success("Profile updated", "Success",10000);
              await getProfileData();
              setEditprofileModal(false);
            } catch (error) { console.error(error); }
          }
        }
        setPhoneNumberChanged(false)
      };

    return(
        <>
    {
        loadingController ?

          <div className="powres_card mt_10 powres_box" >

            <p className="mn_semibold fs-14 text-center" >
              Personal Information
              <span
                className="ml_12 cp edit_left pl_55"


                onClick={openEditProfileModal}
              >
                <img src={pencil} alt="" />
              </span></p>
            <div className="fs-semi-bold fs-14 f-color df_profile mt_20 ">

              <div className="icon_al">
                <BootstrapTooltip title="Phone">
                  <img className="profile_icon mr_31" src={mobile} alt="Phone" />
                </BootstrapTooltip>
              </div>
              <div>
                <p className="fs-semi-bold fs-14 f-color br-word br_word ">
                  {profileData.user ? profileData.user.phoneNumber ?
                    formatPhoneNumberIntl(profileData.user.countryCode + profileData.user.phoneNumber) ?
                      formatPhoneNumberIntl(profileData.user.countryCode + profileData.user.phoneNumber) :
                      profileData.user.phoneNumber

                    : "Phone number not available" : "Phone number not available"}

                </p>
              </div>
            </div>
            <div className="fs-semi-bold fs-14 f-color  df_profile  mt_15 ">
              <div className="icon_alig">
                <BootstrapTooltip title="Location">
                  <img className="profile_icon mr_26" src={location} alt="location" data-tip="Location" data-background-color="#1A8FFF" />
                </BootstrapTooltip>
              </div>
              <div>
                {
                  (locationCountry || locationState || locationCity) ?
                    <p className='br_word'>

                      <span>{locationCity ? locationCity + ", " : ""}</span>
                      <span>{locationState ? locationState + ", " : ""}</span>
                      <span>{locationCountry}</span>
                    </p>
                    :
                    ''
                }
              </div>
            </div>

            <div className="linkedin-wrapper mt_15 ">
              <img src={LinkedIn} alt="linkedIn" />
              {/* <p className=''> */}
              <p
                className={`f-color fs-semi-bold fs-14 email_hidden ${linkedIn ? "wordbreak ml_25 cp" : "ml_26"
                  }`}
                onClick={(e) => openLinkInWinDow(e, linkedIn)}
              >
                {linkedIn ? (linkedIn.substring(0, 30) + (linkedIn.length >=30 ? "...":"") ): "LinkedIn URL not available"}
              </p>
              <span
                className="ml_12 cp edit_left"
                onClick={openLinkedInModal}
              >
                <img src={pencil} alt="" />
              </span>
            </div>
          </div>
          :
          <>
            <div className="powres_card mt_10 powres_box">
              <div className="row">
                <Skeleton variant="text" animation="wave" />
                <div className="df mt_6">
                  <div className="w-100 ml_10">
                    <Skeleton variant="text" animation="wave" />
                  </div>
                </div>
                <Skeleton variant="text" animation="wave" />
                <div className="w-100 ml_10">
                  <Skeleton variant="text" animation="wave" />
                </div>


              </div>
            </div>
          </>

      }

<Dialog
            open={editprofileModal}
            onClose={closeEditProfileModal}
            aria-labelledby="customized-dialog-title"
            maxWidth="sm"
            fullWidth={true}
            className='record-video-intro-responsive'
          >
            <div className="crossFormodal cp" onClick={closeEditProfileModal}><img className="closeicon_set" src={cross} alt=""></img></div>
            <DialogContent sx={styleSx.bodyForEditProfile} className="responsive-body-profilecompletion">
              <div className="dropdown_width_outer mt_12">
                <div className="select customized-select dropdown_width" >
                  <legend>First Name*</legend>
                  <input
                    type="text"
                    className="text_box_cleartalent w-94"
                    value={modalFirstName ? modalFirstName : ""}
                    onChange={(event) => { setModalFirstName(event.target.value) }}
                    placeholder="Enter your First Name"
                  />
                </div>
                <div className="select customized-select dropdown_width zipgap" >
                  <legend>Last Name*</legend>
                  <input
                    type="text"
                    className="text_box_cleartalent w-94"
                    value={modalLastNames ? modalLastNames : ""}
                    onChange={(event) => setModalLastNames(event.target.value)}
                    placeholder="Enter your Last Name"
                  />
                </div>
              </div>
              <div className="dropdown_width_outer mt_12">
                <div className="select customized-select dropdown_width" >
                  <legend>Middle Initial</legend>
                  <input
                    type="text"
                    className="text_box_cleartalent w-94"
                    value={modalMiddleInitial ? modalMiddleInitial : ""}
                    onChange={(event) => setmodalMiddleInitial(event.target.value)}
                    placeholder="Enter your Middle Initial"
                  />
                </div>
                <div className="select customized-select dropdown_width zipgap" >
                  <legend>Email</legend>
                  <input
                    type="text"
                    className="text_box_cleartalent w-94"
                    value={userEmail}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="dropdown_width_outer mt_12">
                <div className="select customized-select dropdown_width">
                  <legend>Country*</legend>
                  <Autocomplete
                    id="combo-box-demo"
                    className="mt_14"
                    options={locationList.countryList}
                    autoHighlight
                    getOptionLabel={(option) => option.name || ""}
                    filterSelectedOptions
                    value={userInformation.locationCountry}
                    onChange={countryHandler}
                    loading={locationList.isCountryFetching}
                    onFocus={() => locationList.countryList.length > 0 ? null : fetchLocationInformation("country")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        required={true}
                        placeholder="Select country"
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {locationList.isCountryFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          },
                        }}
                      />
                    )}
                  />
                </div>
                <div className="select customized-select dropdown_width zipgap" >
                  <div className="select customized-select dropdown_width_recruiter_invite w100 numericContainer">
                    <legend>Phone Number*</legend>
                    <PhoneInput
                      international
                      defaultCountry={defaultCountryCode}
                      className="textbox_phone_input"
                      placeholder="Enter phone number"
                      value={phoneNoIntnl}
                      onChange={(e) => phoneNumberChangeHandler(e)}
                      onKeyPress={(e) => keypressHandler(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="dropdown_width_outer mt_12">
                <Grid container>
                  <Grid size={{ xs: 12, md: 6 }}></Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    {(phoneError) ? (
                      <p className="form-error fs-regular phoneError_ml">
                        Please enter a valid phone number
                      </p>
                    ) : ("")}
                  </Grid>
                </Grid>
              </div>
              <div className="dropdown_width_outer mt_12">
                <div className="select customized-select dropdown_width">
                  <legend>State*</legend>
                  <Autocomplete
                    id="combo-box-State"
                    options={locationList?.stateList}
                    value={userInformation.locationState}
                    className="mt_14"
                    
                    autoHighlight

                    getOptionLabel={(option) => option.name || ""}
                    loading={locationList.isStateFetching}
                    filterSelectedOptions
                    onFocus={() => locationList.stateList.length > 0 ? null : fetchLocationInformation("state")}
                    onChange={stateHandler}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        required={true}
                        placeholder="Select state"
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {locationList.isStateFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          },
                        }}
                      />
                    )}
                  />
                </div>
                <div className="select customized-select dropdown_width">
                  <legend>City</legend>
                  <Autocomplete
                    id="combo-box-City"
                    className="mt_14"
                    options={locationList.cityList}
                    autoHighlight
                    filterSelectedOptions
                    value={userInformation.locationCity}
                    getOptionLabel={(option) => option.name || ""}
                    onFocus={() => locationList.cityList.length > 0 ? null : fetchLocationInformation("city")}
                    loading={locationList.isCityFetching}
                    onChange={cityHandler}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        required={true}
                        placeholder="Select city"
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {locationList.isCityFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          },
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </DialogContent>
            <div className="divider_adjust">
              <hr className="new3 mt_20 mb_0" />
            </div>
            <DialogActions sx={styleSx.buttonAlign} className="responsive-dialog">
              <button
                type="button"
                className="btn-big btn-skill cp"
                onClick={closeEditProfileModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-big btn_powres ml_10 cp"
                onClick={updateProfileData}
              >
                Save
              </button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openLinkedIn}
            onClose={closeLinkedModal}
            aria-labelledby="customized-dialog-title"
            className="linkedin-modal-dialog"
            maxWidth="sm"
          >
            <DialogContent sx={styleSx.bodyForRemove}>
              <div className="ml_5 fs-semi-bold f-color fs-18">
                LinkedIn URL
              </div>
            </DialogContent>
            <DialogActions
            sx={styleSx.buttonAlignForRemove}
              className="responsiveRemove_Modal_button"
            >
              <div className="linkedin-modal-url-container">
                <div className="linkedin-modal-url-container">
                  <input
                    type="text"
                    className="text_box_cleartalent_form1 mb_10"
                    id="email"
                    name="linkedIn"
                    placeholder="Enter LinkedIn URL"
                    value={urlValue}
                    onChange={(e) => setUrlValue(e.target.value)}
                  />
                </div>
                <div className="remove_modal">
                  <button
                    type="button"
                    className="btn-big btn-skill cp"
                    onClick={closeLinkedModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-big btn_powres ml_10 cp"
                    onClick={updateUrl}
                  >
                    Save
                  </button>
                </div>
              </div>
            </DialogActions>
          </Dialog>
    
    </>
    )





}
export default PersonalInformation ;
